module.exports = "/_next/static/images/img_sample-329d756f21a1419672daeb0f0e0bcfc9.jpg";